<template>
  <div class="affix" ref="$el">
	<div class="affix__inner" ref="$inner">
		<slot></slot>
	</div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
	top: {
		type: Number,
		default: 0,
	}
})

const $el = ref(null)
const $inner = ref(null)
let observer;

onMounted(() => {
	check()

	function check() {
		const { top } = $el.value.getBoundingClientRect()

		if (top <= props.top) {
			$el.value.classList.add('affix--fixed')
			$el.value.style.setProperty('--affix-height', `${$inner.value.offsetHeight}px`)
			$el.value.style.setProperty('--affix-top', `${props.top}px`)
		} else {
			$el.value.classList.remove('affix--fixed')
			$el.value.style.removeProperty('--affix-height')
			$el.value.style.removeProperty('--affix-top')
		}

		observer = requestAnimationFrame(check)
	}
})

onBeforeUnmount(() => {
	cancelAnimationFrame(observer)
})
</script>

<style lang="scss">
.affix {
	padding-bottom: var(--affix-height, 0);

	&.affix--fixed {
		.affix__inner {
			position: fixed;
			top: var(--affix-top, 0px);
			left: 0;
			width: 100%;
			z-index: 50;
		}
	}
}
</style>
